<template>
  <q-select
    class="items-center"
    v-model="items"
    dense
    outlined
    use-input
    ref="selectRef"
    :label="label"
    :clearable="clearable"
    :disable="disable"
    :multiple="multiple"
    :use-chips="multiple"
    :options="filterOptions"
    :option-label="getoptionLabel"
    :option-value="optionValue"
    :emit-value="emitValue"
    :popup-content-style="{ width: `${$refs.selectRef?.$el.clientWidth}px` }"
    @filter="filter"
    @clear="clear"
    @update:model-value="input"
  >
    <template v-slot:prepend>
      <slot name="prepend"></slot>
    </template>

    <template v-if="optionCaption" v-slot:option="scope">
      <q-item clickable v-bind="scope.itemProps">
        <q-item-section>
          <q-item-label>
            {{ getoptionLabel(scope.opt) }}
          </q-item-label>
          <q-item-label caption>
            {{ scope.opt[optionCaption] }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>

    <template v-if="multiple" v-slot:selected-item="scope">
      <span
        v-if="draggable"
        draggable="true"
        @dragstart="dragstart($event, scope)"
        @dragover.prevent
        @dragenter.prevent
        @drop="drop($event, scope)"
      >
        <q-chip
          class="cursor-move"
          dense
          removable
          :dark="false"
          icon="drag_indicator"
          :label="getoptionLabel(scope.opt)"
          @remove="scope.removeAtIndex(scope.index)"
        />
      </span>
      <q-chip
        v-else
        dense
        removable
        :dark="false"
        @remove="scope.removeAtIndex(scope.index)"
        :label="getoptionLabel(scope.opt)"
      >
        <q-tooltip v-if="tooltipCaption && getTooltipCaption(scope.opt)">
          {{ getTooltipCaption(scope.opt) }}
        </q-tooltip>
      </q-chip>
    </template>
  </q-select>
</template>

<script>
export default {
  name: "AppSelect",
  props: {
    modelValue: {},
    options: Array,
    label: String,
    clearable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    multiple: Boolean,
    draggable: Boolean,
    dragKey: String,
    optionLabel: {},
    optionValue: {},
    optionCaption: {},
    tooltipCaption: undefined,
    emitValue: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: this.modelValue ?? (this.multiple ? [] : undefined),
      filterOptions: [],
    };
  },
  watch: {
    modelValue() {
      // console.log("AppSelect this.modelValue", this.modelValue);
      this.items = this.modelValue;
    },
  },
  methods: {
    getTooltipCaption(guid) {
      return this.options.find((option) => option?.class_guid === guid)?.[
        this.tooltipCaption
      ];
    },
    getoptionLabel(key) {
      if (!this.optionValue) {
        return key;
      }
      const k = typeof key == "object" ? key[this.optionValue] : key;
      if (this.optionLabel) {
        if (typeof this.optionLabel == "string") {
          const option = this.options.find((x) => x[this.optionValue] == k);
          if (option) {
            return option[this.optionLabel];
          } else {
            return k;
          }
        } else {
          return this.optionLabel(k);
        }
      }
    },
    filter(val, update) {
      update(() => {
        this.filterOptions = !val
          ? this.options
          : this.options.filter(
              (v) =>
                JSON.stringify(v).toLowerCase().indexOf(val.toLowerCase()) > -1,
            );
      });
    },
    dragstart(e, item) {
      // console.log("dragstart", e, item);
      e.dataTransfer.setData("index", item.index);
      if (this.dragKey) {
        e.dataTransfer.setData(this.dragKey, item.opt);
      }
    },
    drop(e, item) {
      // console.log("drop", e, item);
      let index_from = e.dataTransfer.getData("index");
      let index_to = item.index;
      // вставляем элемент из index_from в index_to
      this.items.splice(index_to, 0, this.items.splice(index_from, 1)[0]);
    },
    clear() {
      console.log("AppSelect clear | this.multiple", this.multiple);
      this.items = this.multiple ? [] : undefined;
      this.input();
    },
    input(items = undefined) {
      // if (this.items === null) return;
      this.$emit("update:model-value", this.items);
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
